module.exports = __webpack_public_path__ + "media/video_202412.3a0163be.webm";